// extracted by mini-css-extract-plugin
export default {"imageBox":"style_imageBox__Hfn59","carouselIcon":"style_carouselIcon__HURoT"};